import { TaskValue } from 'lib/actions/task'
import { GetExternalTicketResponse } from 'pbts/c1/api/external_tickets/v1/external_tickets'
import { ProvisionInstance } from 'pbts/c1/api/policy/v1/policy'
import { GetExternalTicketApi } from 'redux_toolkit/external_tickets'
import { SerializedErrorType } from 'redux_toolkit/lib/reducer'

const getProvisionInstance = (task: TaskValue): ProvisionInstance | undefined =>
    (task.policy?.current?.instance?.oneofKind === 'provision'
        ? task.policy.current.instance.provision
        : undefined)

export const useGetExternalTicket = ({
    task,
}: {
    task: TaskValue;
}): [
    boolean,
    Readonly<SerializedErrorType> | undefined,
    Readonly<GetExternalTicketResponse> | undefined
] => {
    const provisionInstance = getProvisionInstance(task)
    const provisionerConfigId = provisionInstance?.externalTicketProvisionerConfigId || ''
    const externalTicketId = provisionInstance?.externalTicketId || ''

    const {
        data: externalTicket,
        isLoading: isLoadingExternalTicket,
        error: errorExternalTicket,
    } = GetExternalTicketApi.useGetExternalTicket({
        externalTicketId,
        provisionerConfigId,
    }, {
        actionable: !!externalTicketId
        && !!provisionerConfigId,
    })

    return [isLoadingExternalTicket, errorExternalTicket, externalTicket]
}
